import { h } from "snabbdom";
import type { VNode } from "snabbdom";
import type { Msg } from "../types";

export function viewConfirmDelete(id: string, dispatch: (msg: Msg) => void): VNode {
  return h(
    "div.modal-overlay",
    { on: { click: () => dispatch({ type: "CancelDelete" }) } },
    [
      h("div.modal.confirm", { on: { click: (e: Event) => e.stopPropagation() } }, [
        h("h2.confirm__title", "Delete card?"),
        h("p.confirm__text", "This permanently deletes the card and cannot be undone."),
        h("div.confirm__actions", [
          h(
            "button.confirm__btn",
            { attrs: { type: "button" }, on: { click: () => dispatch({ type: "CancelDelete" }) } },
            "Cancel"
          ),
          h(
            "button.confirm__btn.confirm__btn--danger",
            {
              attrs: { type: "button" },
              on: { click: () => dispatch({ type: "ConfirmDeleteCard", id }) },
            },
            "Delete"
          ),
        ]),
      ]),
    ]
  );
}
